import React from "react";
import {
  Grid,
  /* Typography, 
  Button,*/
} from "@material-ui/core";
import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import ArrowButtonLink from './../../../shared/components/ArrowButtonLink';
import SectionLineTitle from './../../../shared/components/SectionLineTitle';
import { cdnURL } from 'shared/functions/api/'
import moment from 'moment'
import { Link } from 'react-router-dom'
import DynamicElement from 'shared/components/DynamicElement';
import {
  withStyles,
  withWidth,
} from "@material-ui/core";

const styles = (theme) => ({

});

const useStyles = makeStyles({
  root: {
    //maxWidth: 345,
    backgroundColor: '#121416',
    margin: '0 auto',
  },
  media: {
    height: 210,
    margin: 14,
    marginTop: 0,
    marginBottom: 0,
  },
  cardContent: {
    backgroundColor: '#121416'
  },
  noDecoration: {
    textDecoration: 'none'
  }
});

const MainText = styled.div`
  font-family: MinionPro-Disp;
  font-size: 72px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  text-align: left;
  color: #313438;
`;

const DateText = styled.div`
  height: 15px;
  font-family: Lato;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  text-align: left;
  color: #b6b8bc;
`;

const Description = styled.p`
  height: 72px;
  font-family: Lato;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.56;
  letter-spacing: 0.16px;
  text-align: left;
  color: #ffffff;
`;


function NewsSection(props) {
  const { blogPosts = [] } = props;

  const classes = useStyles();

  return (
    <div id={props.id} style={{ backgroundColor: "#121416", position: 'relative', height: '100vh', display: 'flex' }}>
      <div className="container-fluid lg-p-top" style={{ margin: 'auto' }}>

        <DynamicElement to="/admin/posts" style={{ position: 'absolute', top: 80, right: 20 }}>
          Manage News
        </DynamicElement>


        <div>
          <Grid
            style={{ minHeight: "100px", width: "100%", padding: 0 }}
            spacing={0}
            container
          >
            <Grid
              style={{ minHeight: "100px", width: "100%", padding: 0 }}
              spacing={0}
              container
            >
              <Grid
                style={{ minHeight: "100px", width: "100%", padding: 0 }}
                lg={6}
                sm={6}
                md={6}
                xs={12}
                item
              >
                <MainText>
                  <DynamicElement id="5ff65eb32a34245c31b64e04">
                    {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
                  </DynamicElement>
                </MainText>
              </Grid>
              <Grid
                style={{ minHeight: "100px", width: "100%", padding: 0 }}
                lg={6}
                sm={6}
                md={6}
                xs={12}
                item
                align="right"
              >
                <SectionLineTitle size="small">
                  <DynamicElement id="5ff65f362a34245c31b64e05">
                    {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
                  </DynamicElement>
                </SectionLineTitle>
              </Grid>
            </Grid>


            <Grid
              style={{ minHeight: "100px", width: "100%", padding: 0, marginTop: -37 }}
              spacing={0}
              container
            >
              {blogPosts.slice(0, 3).map((post, i) =>
                <Grid
                  key={i}
                  style={{ minHeight: "100px", width: "100%", padding: 10, paddingLeft: 25, paddingRight: 25 }}
                  lg={4}
                  sm={4}
                  md={4}
                  xs={12}
                  item
                >
                  <Link className={classes.noDecoration} to={post.url}>
                    <Card className={classes.root}>
                      <CardActionArea>
                        <CardMedia
                          className={classes.media}
                          image={cdnURL + post.src}
                          title="Contemplative Reptile"
                        />
                        <CardContent classes={{ root: classes.cardContent }}>
                          {/* <Typography gutterBottom variant="h5" component="h2">
                          Lizard
                        </Typography> */}
                          <DateText>{moment(post.date).format('DD MMMM YYYY')}</DateText>
                          <Description>
                            {post.title}
                          </Description>
                        </CardContent>
                      </CardActionArea>
                    </Card>
                  </Link>
                </Grid>
              )}


            </Grid>
            <Grid container>
              <Grid
                style={{
                  minHeight: "100px",
                  width: "100%",
                  padding: 85,
                  paddingTop: 75,
                  paddingBottom: 75,
                  textAlign: "center"
                }}
                xs={12}
                item
              >
                <ArrowButtonLink to={'/news'} label={'View All'} />
              </Grid>
            </Grid>
          </Grid>
        </div>

      </div>
    </div>
  );
}

const MobileWrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  background-color: #121416;

  .MainText{
    font-size: 55px;
    line-height: 1;
    color: #313438;
    padding-top: 100px;
    text-align: center;
  }
  .SectionLineTitleWrap{
    margin-top: 24px;
    margin-right: 24px;
    text-align: right;
    margin-bottom: 24px;
  }

  .MuiCardMedia-root{
    width: 125px;
    float: left;
    background-size: contain;
    height: 100px;
  }

  .MuiCardContent-root{
    padding-top: 0;
  }

  .description{
    font-size: 13px;
    height: auto;
    overflow: hidden;
    display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;  
  }
`;

const SectionWrapper = (props) => {
  const classes = useStyles();
  if (props.width === 'xs') {
    const { blogPosts = [] } = props;
    return <MobileWrapper>
      <MainText className="MainText">
        <DynamicElement id="5ff65eb32a34245c31b64e04">
          {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
        </DynamicElement>
      </MainText>
      <div className="SectionLineTitleWrap">
        <SectionLineTitle size="small">
          <DynamicElement id="5ff65f362a34245c31b64e05">
            {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
          </DynamicElement>
        </SectionLineTitle>
      </div>

      <Grid
        style={{ minHeight: "100px", width: "100%", padding: 0, marginTop: -37 }}
        spacing={0}
        container
        direction="column"
      >
        {blogPosts.slice(0, 3).map((post, i) =>
          <Grid
            key={i}
            style={{ minHeight: "150px", width: "100%", padding: 10, paddingTop: 0, paddingLeft: 25, paddingRight: 25 }}
            xs={12}
            item
          >
            <Link className={classes.noDecoration} to={post.url}>
              <Card className={classes.root}>
                <CardActionArea>
                  <CardMedia
                    className={classes.media}
                    image={cdnURL + post.src}
                    title="Contemplative Reptile"
                  />
                  <CardContent classes={{ root: classes.cardContent }}>
                    {/* <Typography gutterBottom variant="h5" component="h2">...</Typography> */}
                    <DateText>{moment(post.date).format('DD MMMM YYYY')}</DateText>
                    <Description className="description">
                      {post.title}
                    </Description>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Link>
          </Grid>
        )}


      </Grid>
      <Grid container>
        <Grid
          style={{
            width: "100%",
            paddingTop: 30,
            paddingBottom: 40,
            textAlign: "center"
          }}
          xs={12}
          item
        >
          <ArrowButtonLink to={'/news'} label={'View All'} />
        </Grid>
      </Grid>
    </MobileWrapper>
  } else {
    return <NewsSection {...props} />
  }
}

export default React.memo(withWidth()(withStyles(styles, { withTheme: true })(SectionWrapper)));
